import { useState, useEffect,useRef } from "react"
import React from 'react'
import { useForm } from '../forms/useForm';
import 'moment/locale/es';
import moment from 'moment';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import {getGlobalCash,createCashGlobal,createCashExtemporaneous} from '../../services/cashFlow/cashFlow'




export const useCashGlobal = () => {
        
    // * GLOBALES
    let _commercialLine = localStorage.getItem('CommercialLineShort');
    let _nameUser= localStorage.getItem('nameUser');
    let _branchName= localStorage.getItem('branchName');
    let _admin_cash= localStorage.getItem('admin_cash');
    let _active_micro = localStorage.getItem('active_microsanitary');
    let _url_helen = localStorage.getItem('url_helen');



   
    const [createSweet] = useSweetAlert();
    
    // ? GLOBAL CASH
    const [dataAllGlobal, setDataAllGlobal] = useState([])
    const [amount1, setAmount1] = useState(0);
    const [loadingGlobal, setLoadingGlobal] = useState(false)
    const [amountTotal, setAmountTotal] = useState(0);
    const [amountCancell, setAmountCancell] = useState(0);


    // ? AUTHORIZATION CASH
    const [selectedKey, setSelectedKey] = useState(null); 
    const [modalAuthorization, setModalAuthorization] = useState(false);
    const [viewAmount, setViewAmount] = useState(null)
    const [user, setUser] = useState(null)

    // ? PREVIEW
    const [viewDetail, setViewDetail] = useState(false);
    const [id_cash, setId_cash] = useState(null);

    // ? EXTEMPORANEOUS
    const [visibleTicket, setVisibleTicket] = useState(false); 
    const [infoTicket, setInfoTicket] = useState([]);
    const toast = useRef(null); 
    const [userCapture, setUserCapture] = useState("");
    const [loadingExtemporaneous, setLoadingExtemporaneous] = useState(false)


    
     




    // ? FORM CASH
    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValues, handlePickerValues] = useForm({
        date1: "",
        date2: "",
    });

    const {date1,date2} = formValues;

    // * CONFIGURATION GLOBAL
    const today = moment().format("YYYY-MM-DD");
    let _date1 = (date1 === '') ? today : moment(date1).format("YYYY-MM-DD");
    let _date2 = (date2 === '') ? today : moment(date2).format("YYYY-MM-DD");

    // *CONFIGURATION DATE
    const now = new Date();
    const fecha = now.toLocaleDateString(); 
    const hora = now.toLocaleTimeString(); 
    let _new = (fecha + " " + hora)

    // * CONFIGURATION PREVIEW

    const handleOpenPreview = () => 
    {
        setViewDetail(true)
    }

    const handleClosedPreview = () => 
    {
        setViewDetail(false)
    }


    // * EFFECTS
    useEffect(() => {
        handleGetGlobalCash()
    }, [])

    // * TOOGLE
    const toogleAuthorization = () => 
    {
        setModalAuthorization(!modalAuthorization)
    }

    // ? METHOD GLOBAL
    const handleGetGlobalCash = async (_valid) => 
    {

        setLoadingGlobal(true)
        const allCash = await getGlobalCash(_date1, _date2);
    
        if (allCash?.length > 0) {
            if (_valid) {
                setLoadingExtemporaneous(false)
                createSweet("success", "success", "Corte de Caja Extemporaneo realizado correctamente");
                hideModalTicket() 
            }
            
            setLoadingGlobal(false)

            let _update = [];
            
            
            allCash.forEach(_branch => {
                let _sum_branch = 0;
                let _sum_amountCash = 0;  
    
                _branch.detailBranches.forEach(_pay => {
                    _pay.pay_methods.forEach(_amount => {
                        if (_amount?.id_pay_method === 1) {
                            _sum_branch += _amount?.amount;
                        }
                    });

                    _pay.cash.forEach(_cashItem => {
                        _sum_amountCash += _cashItem?.amount ?? 0 
                    });
                });
    
                _update.push({
                    ..._branch,
                    amount: _sum_branch,      
                    amountCash: _sum_amountCash, 
                });
            });
    
            setDataAllGlobal(_update);
            setAmount1(_update.reduce((acc, branch) => acc + branch.amount, 0)); 
            setAmountTotal(_update.reduce((acc, branch) => acc + branch.amount_total, 0));
            setAmountCancell(_update.reduce((acc, branch) => acc + branch.amount_cancell, 0));
        } else {
            setDataAllGlobal([]);
        }
    };

    // ? CONFIGURATION AUTHORIZATION CASH
    const handleSearchAuthorization = (_key_user, _key_branch,_key_detail,_amounts,_user,_id_cash) => 
    {
        const key = `${_key_user}-${_key_branch}-${_key_detail}`;
    
        setSelectedKey(prevSelectedKey => (prevSelectedKey === key ? null : key));
        setModalAuthorization(!modalAuthorization)
        setViewAmount(_amounts)
        setUser(_user)
        setId_cash(_id_cash)
    };

    // ? SAVE CHANGUES
    const saveCourtesyPatient = async (_authorization_date,_id_cash) => 
    {
        let _new = moment(now).format("YYYY-MM-DD HH:mm:ss"); 

        const response = await createCashGlobal(_new,_id_cash);

        if (response.code === 200) {
            createSweet("success", "success", "Autorizado", "Se a validado correctamente este corte");
            handleGetGlobalCash()
            toogleAuthorization()
        }
    }

    // ? EXTEMPORANEOUS
    const getFormattedDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
    
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
    };
    
    
    const [formextemporaneus, setFormExtemporaneous] = useState({
        comment: null,
        amount: 0,
        id_work_order_first:0,
        id_work_order_last: 0,
        id_user_extemporaneous:0,
        date_extemporaneous:getFormattedDate(),
        amount_capture: 0,
        id_branch:0

    });

    const showSuccess = () => {
        
        if (toast.current) {
            toast.current.show({
                severity: 'success',
                summary: 'Éxito',
                detail: 'La busqueda del corte se realizo de la manera correcta',
                life: 3000
            });
        }
    };
  
    const showModalTicket = (_search) => {
        setInfoTicket(_search);
        showSuccess();
        setUserCapture(_search.userCapture ?? "----");
        
        const _id_pay_method1 = _search.pay_methods.find(method => method.id_pay_method === 1);
        
        const _amount = _id_pay_method1 ? _id_pay_method1?.amount : 0;
        
        setFormExtemporaneous({
            ...formextemporaneus,
            id_work_order_first: _search.first_id_work_order,
            id_work_order_last: _search.end_id_work_order,
            id_user_extemporaneous: _search?.id_user,
            amount_capture: _amount,
            id_branch: _search?.id_branch
        });
        
        setVisibleTicket(true);
    };
    
    const hideModalTicket = () => 
    {
        setVisibleTicket(false);
    };

    const handleComment = (e) => 
    {
        const _comment = e?.target?.value;  
        if (e !== null && e?.target?.value !== undefined) {
            setFormExtemporaneous({
                ...formextemporaneus,
                comment: _comment,
            }); 
        }
        else {
            setFormExtemporaneous({
                ...formextemporaneus,
                comment: null,
            }); 
        }
    }

    const handleAmount = (e) => 
    {
        const _amount = e?.target?.value;  
        if (e !== null && e?.target?.value !== undefined) {
            setFormExtemporaneous({
                ...formextemporaneus,
                amount: _amount,
            }); 
        }
        else {
            setFormExtemporaneous({
                ...formextemporaneus,
                amount: null,
            }); 
        }
    }

    const createExtemporaneous = async (_fech) => 
    {
      setLoadingExtemporaneous(true)

      const create = await createCashExtemporaneous(formextemporaneus.comment,formextemporaneus.amount_capture,formextemporaneus.amount,formextemporaneus.id_branch, formextemporaneus.id_work_order_first,formextemporaneus.id_work_order_last, formextemporaneus.date_extemporaneous, formextemporaneus.id_user_extemporaneous,_fech);
        
      if (create.code === 200) {
        handleGetGlobalCash(true)
        setFormExtemporaneous({
            ...formextemporaneus,
            id_work_order_first: 0,
            id_work_order_last: 0,
            id_user_extemporaneous: 0,
            amount_capture: 0,
            id_branch: 0,
            amount:0,
            comment:null,
            date_cash: null
        });
      }
      else {
        setLoadingExtemporaneous(false)
        createSweet("error", "error", "Error", "Se genero un problema al crear el corte de caja extemporaneo")  ;
      }
    }

 


    // * FUNCTION FORMAT
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    })



    return {
        // ? CONFIGURATION
        _commercialLine,_nameUser,_branchName,_new,_admin_cash,

        // ? FORM 
        date1, date2, handleInputChange,
        
        // ? TYPE FORMAT
        formatter,

        // ? GLOBAL CASH
        dataAllGlobal,handleGetGlobalCash,amount1,loadingGlobal,amountTotal, amountCancell,

        // ? AUTHORIZATION CASH
        handleSearchAuthorization,selectedKey,toogleAuthorization,modalAuthorization,handleOpenPreview,handleClosedPreview,viewDetail,viewAmount,user,id_cash,saveCourtesyPatient,
        _active_micro,_url_helen,

        // ? EXTEMPORANEOUS
        visibleTicket,showModalTicket,hideModalTicket,infoTicket,toast,userCapture,
        handleComment,handleAmount,formextemporaneus,createExtemporaneous,loadingExtemporaneous


    }
}
